import { ReebeloBatteryHealth } from '@lambda/reebelo';
import atnt from '@/public/icons/collection/at-t.svg';
import tMobile from '@/public/icons/collection/t-mobile.svg';
import verizon from '@/public/icons/collection/verizon.svg';
import unlocked from '@/public/icons/collection/unlocked.svg';

type ImgSrcType = {
  src: string;
  height: number;
  width: number;
};

type SvcImgType = {
  image: ImgSrcType;
  size: string;
};

export const generateBatteryHealthTitle = (batteryHealth: string) => {
  if (batteryHealth === ReebeloBatteryHealth.BH_100) {
    return `New`;
  }

  if (batteryHealth === ReebeloBatteryHealth.BH_90) {
    return `Elevated`;
  }

  return `Standard`;
};

export const getCarrierImage: (serviceProvider: string) => SvcImgType = (
  serviceProvider,
) => {
  const svcProviderImgMap: Record<string, SvcImgType> = {
    'AT&T': {
      image: atnt,
      size: 'h-[18px]',
    },
    Verizon: {
      image: verizon,
      size: 'h-[15px]',
    },
    'T-Mobile': {
      image: tMobile,
      size: 'h-[12px]',
    },
    Unlocked: {
      image: unlocked,
      size: 'h-[12px] md:h-[14px]',
    },
  };

  return svcProviderImgMap[serviceProvider];
};

export const getContrastYIQ = (hexcolor: string) => {
  const r = parseInt(hexcolor?.substr(0, 2), 16);
  const g = parseInt(hexcolor?.substr(2, 2), 16);
  const b = parseInt(hexcolor?.substr(4, 2), 16);
  const yiq = (r * 299 + g * 587 + b * 114) / 1000;

  return yiq >= 128 ? 'black' : 'white';
};

export const getBatteryHealthLabel = (batteryHealth: string) => {
  if (batteryHealth === ReebeloBatteryHealth.BH_100) {
    return `${batteryHealth}%`;
  }

  return `Min. ${batteryHealth}%`;
};
